export const checkAdminAccess = (role: string | null, roles: string[]) => {
  if (role) {
    const hasAccess = roles.find((tempRole) => tempRole === role);

    if (hasAccess) {
      return true;
    }
  }

  return false;
};
